import { useState, useEffect } from 'react';

/**
 * Custom hook to get the current URL hash and update it on hash change.
 * @returns {string} The current URL hash.
 */
export const useHash = (): string => {
  const [hash, setHash] = useState<string>(getHashFromUrl());

  useEffect(() => {
    const onHashChange = () => {
      setHash(getHashFromUrl());
    };

    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);
  return hash;
};

/**
 * Get the hash from the URL, handling both the hash and encoded hash cases.
 * @returns {string} The decoded hash.
 */
const getHashFromUrl = (): string => {
  if (typeof window === 'undefined' || !window.location) {
    return '';
  }
  const hash = window.location.hash;
  if (hash) {
    return hash;
  }

  const url = window.location.href;
  const encodedHashIndex = url.indexOf('%23');
  if (encodedHashIndex !== -1) {
    return url.substring(encodedHashIndex + 3);
  }

  return '';
};
